import {Tabs, Tab} from "@mui/material";
import {styled} from "@mui/system";

const CustomTabs = styled(Tabs)({
    minHeight: "40px",
    '& .MuiTabs-indicator': {
        display: 'none',
    },
});

const CustomTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minHeight: '40px',
    borderRadius: '8px',
    border: "1px solid #7A78F7C9",
    color: "#3333CFF7",
    fontWeight: "normal",
    '&.Mui-selected': {
        backgroundColor: '#d8d8fd',
        color: "#3333CFF7",
        border: "none",
        fontWeight: "bold",
    },
    '&.Mui-focusVisible': {
        backgroundColor: '#d7d4f0',
    },
    '&:hover': {
        backgroundColor: '#f0f0f0',
    },
}));

export {CustomTabs, CustomTab}

